import { QueryExportInput } from '../gql/graphql'
import { queryExportMutation } from '../queries/graphql/graphqlQueries'
import { stripQueryExportInput } from '../utils/tableConfigUtils'
import { apolloClient } from './apolloClient'

export type SortCriteria = Record<string, unknown>

/**
 *  TODO: make always present columns required in future
 * need to make sure all consumption of filter criteria passes through the
 * standardizer/defaulter for values. This will reduce conditional checks
 * on filterCriteria fields across the app, as we'll ensure fields exist
 * at injestion..
 * */
export type FilterCriteria = Record<string, unknown>

export type ExportColumn = Record<string, unknown>

export const exportFile = async (exportOptions: QueryExportInput) => {
  try {
    const rawInput: QueryExportInput = {
      ...exportOptions,
      fileName:
        exportOptions.fileName ||
        `${exportOptions.queryDefinitionId}-export.csv`,
    }
    const input = stripQueryExportInput(
      rawInput as Record<string, unknown>,
    ) as QueryExportInput

    const result = await apolloClient.mutate({
      mutation: queryExportMutation as any,
      variables: { input },
    })
    if (result.error) {
      throw new Error(result.error.message)
    }
    return (result.data as { queryExport?: unknown } | undefined)?.queryExport
  } catch (e: unknown) {
    throw e
  }
}
